import {
  IncidentOwnershipFilter,
  IncidentUrgencyFilter,
  IncidentMetadataFilter,
  OWNERSHIP_OPTIONS,
  URGENCY_OPTIONS,
  METADATA_OPTIONS,
} from 'hooks/useMapSearch';
import { parseArrayParam } from 'hooks/useQueryParams';
import { IncidentFiltersState } from '../../../state/useIncidentFiltersState';

/**
 * Parse and validate URL params into clean filter state
 */
export const parseFiltersFromURLParams = (params: {
  ownership?: string | null;
  urgency?: string | null;
  metadata?: string | null;
}): IncidentFiltersState => {
  // Validate ownership (single value)
  const allowedOwnershipValues = OWNERSHIP_OPTIONS.filter(
    (opt) => opt.value,
  ).map((opt) => opt.value as IncidentOwnershipFilter);

  const ownership =
    params.ownership &&
    allowedOwnershipValues.includes(params.ownership as IncidentOwnershipFilter)
      ? (params.ownership as IncidentOwnershipFilter)
      : null;

  // Validate urgency (array)
  const urgency = parseArrayParam<IncidentUrgencyFilter>(
    params.urgency || null,
    URGENCY_OPTIONS.map((opt) => opt.value),
  );

  // Validate metadata (array)
  const metadata = parseArrayParam<IncidentMetadataFilter>(
    params.metadata || null,
    METADATA_OPTIONS.map((opt) => opt.value),
  );

  return {
    ownership,
    urgency,
    metadata,
  };
};
